import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Lock, KeyRound } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await login(email, password);
      toast.success("Welcome back");
      navigate("/admin");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#EFF0F2] dark:bg-[#12100E] flex items-center justify-center px-4">
      <div className="w-full max-w-md animate-fade-up">
        <Link to="/" className="flex justify-center">
          <img src="/logo.png" alt="Ricky Rooms Lettings" className="h-24 w-auto" />
        </Link>
        <p className="mt-2 text-center text-xs uppercase tracking-[0.2em] font-mono text-[#8A837C] dark:text-[#8E867E]">
          Owner Portal
        </p>
        <form
          onSubmit={submit}
          data-testid="admin-login-form"
          className="mt-8 rounded-2xl border border-[#E4DBD0] dark:border-[#352F2B] bg-white dark:bg-[#1A1715] p-8 space-y-5"
        >
          <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-[#F4EFEA] dark:bg-[#231F1C]">
            <Lock className="h-5 w-5 text-[#A05A32] dark:text-[#D9773F]" />
          </div>
          <div className="space-y-2">
            <Label htmlFor="admin-email">Email</Label>
            <Input
              id="admin-email"
              data-testid="admin-login-email"
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@example.com"
              className="h-11"
            />
          </div>
          <div className="space-y-2">
            <Label htmlFor="admin-password">Password</Label>
            <Input
              id="admin-password"
              data-testid="admin-login-password"
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
              className="h-11"
            />
          </div>
          <Button
            data-testid="admin-login-submit"
            type="submit"
            disabled={submitting}
            className="w-full h-11 rounded-full bg-[#A05A32] hover:bg-[#864522] text-[#EFF0F2]"
          >
            {submitting ? "Signing in..." : "Sign in"}
          </Button>
          <button
            type="button"
            data-testid="admin-login-demo-btn"
            onClick={() => { setEmail("ricky@rickyrooms.co.uk"); setPassword("admin123"); }}
            className="w-full inline-flex items-center justify-center gap-1.5 text-xs text-[#8A837C] dark:text-[#8E867E] hover:text-[#A05A32] dark:hover:text-[#D9773F] transition-colors"
          >
            <KeyRound className="h-3 w-3" /> Autofill demo credentials
          </button>
        </form>
      </div>
    </div>
  );
}
